module.exports = __webpack_public_path__ + "media/images/earth-night-da273783100dfbfd07c02d8513b6999c.jpg";